// ReferralSettings.js
import { useState, useEffect } from "react";
import {
  getReferralSettings,
  updateReferralSettings,
} from "../../service/Mainservice";
import Loader from "../../Loader/Loader";
import "./ReferralSettings.css";

// MUI Icons
import PeopleIcon from "@mui/icons-material/People";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SaveIcon from "@mui/icons-material/Save";
import ReferralList from "./ReferralList";

const ReferralSettings = () => {
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({
    driverBonus: 0,
    customerBonus: 0,
  });
  const [saving, setSaving] = useState(false);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const res = await getReferralSettings();
      setSettings(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateReferralSettings(settings);
      alert("Referral settings updated successfully.");
    } catch (err) {
      alert(err.response?.data?.message || "Update failed.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="referral-settings">
      {loading ? (
        <Loader />
      ) : (
        <form className="settings-form" onSubmit={handleSubmit}>
          <div className="settings-card">
            <div className="settings-icon">
              <PeopleIcon />
            </div>
            <div className="settings-content">
              <h3>Referral Bonuses</h3>
              <p>
                Set the bonus amounts for customers and drivers when they refer
                new users.
              </p>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>
                <AttachMoneyIcon fontSize="small" /> Driver Bonus ($)
              </label>
              <input
                type="number"
                value={settings.driverBonus}
                onChange={(e) =>
                  setSettings({
                    ...settings,
                    driverBonus: parseFloat(e.target.value) || 0,
                  })
                }
                min="0"
                step="0.01"
              />
              <small>
                Amount credited to driver when their referral signs up.
              </small>
            </div>
            <div className="form-group">
              <label>
                <AttachMoneyIcon fontSize="small" /> Customer Bonus ($)
              </label>
              <input
                type="number"
                value={settings.customerBonus}
                onChange={(e) =>
                  setSettings({
                    ...settings,
                    customerBonus: parseFloat(e.target.value) || 0,
                  })
                }
                min="0"
                step="0.01"
              />
              <small>
                Amount credited to customer when their referral signs up.
              </small>
            </div>
          </div>

          <button type="submit" className="btn-primary" disabled={saving}>
            <SaveIcon fontSize="small" />{" "}
            {saving ? "Saving..." : "Save Settings"}
          </button>
        </form>
      )}
      <ReferralList />
    </div>
  );
};

export default ReferralSettings;
